import { AxiosResponse, AxiosError } from "axios";
import request from "#/utils/request";
import InternalResponse from "#/types/internalResponse";
import { authHeaders } from "#/modules/auth/idp";

export type PolicyNameMapping = Record<string, string>;

export default function getPolicyNameMapping({
  token,
}: {
  token: string;
}): Promise<InternalResponse<PolicyNameMapping>> {
  return request()({
    url: "/xecguard/v1/internal/policy-friendly-name-mapping",
    method: "GET",
    headers: authHeaders(token),
  }).then(
    (result: AxiosResponse<PolicyNameMapping>): InternalResponse<PolicyNameMapping> => ({
      statusCode: result.status,
      data: result.data,
      success: true,
    }),
  ).catch((error: AxiosError): InternalResponse => ({
    statusCode: error.code,
    msg: error.message,
    success: false,
  }));
}
